/**
 * GraphQL queries for Shopify products
 */

/**
 * Query to get products
 */
export const GET_PRODUCTS = `
  query GetProducts($first: Int!, $after: String, $query: String, $sortKey: ProductSortKeys, $reverse: Boolean) {
    products(first: $first, after: $after, query: $query, sortKey: $sortKey, reverse: $reverse) {
      nodes {
        id
        title
        description
        handle
        productType
        vendor
        tags
        createdAt
        updatedAt
        publishedAt
        options {
          id
          name
          values
        }
        variants(first: 250) {
          nodes {
            id
            title
            sku
            availableForSale
            requiresShipping
            selectedOptions {
              name
              value
            }
            price {
              amount
              currencyCode
            }
            compareAtPrice {
              amount
              currencyCode
            }
            image {
              id
              url
              altText
              width
              height
            }
          }
        }
        images(first: 20) {
          nodes {
            id
            url
            altText
            width
            height
          }
        }
        collections(first: 20) {
          nodes {
            id
            title
            description
            updatedAt
          }
        }
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
          maxVariantPrice {
            amount
            currencyCode
          }
        }
        compareAtPriceRange {
          minVariantPrice {
            amount
            currencyCode
          }
          maxVariantPrice {
            amount
            currencyCode
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * Query to get a product by ID
 */
export const GET_PRODUCT = `
  query GetProduct($id: ID, $handle: String) {
    product(id: $id, handle: $handle) {
      id
      title
      description
      handle
      productType
      vendor
      tags
      createdAt
      updatedAt
      publishedAt
      descriptionHtml
      description
      options {
        id
        name
        values
      }
      variants(first: 250) {
        nodes {
          id
          title
          sku
          availableForSale
          requiresShipping
          selectedOptions {
            name
            value
          }
          price {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }
          image {
            id
            url
            altText
            width
            height
          }
        }
      }
      images(first: 20) {
        nodes {
          id
          url
          altText
          width
          height
        }
      }
      collections(first: 20) {
        nodes {
          id
          title
          description
          updatedAt
        }
      }
      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      compareAtPriceRange {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      metafields(identifiers: [
        {namespace: "translations", key: "title_hi"},
        {namespace: "translations", key: "description_hi"},
        {namespace: "translations", key: "short_description_hi"}
        {namespace: "reviews", key: "rating"},
        {namespace: "reviews", key: "rating_count"},
      ]) {
        namespace
        key
        value
        type
      }
    }
  }
`;
